const GPay = ({ ...props }) => {
  return (
    <svg
      width="38"
      height="24"
      viewBox="0 0 38 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6206_121271)">
        <path
          opacity="0.07"
          d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
          fill="black"
        />
        <path
          d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z"
          fill="white"
        />
        <g clipPath="url(#clip1_6206_121271)">
          <path
            d="M18.2302 12.2065V15.3798H17.1802V7.53198H19.9102C20.5752 7.53198 21.2052 7.77083 21.6952 8.2144C22.1852 8.62385 22.4302 9.23802 22.4302 9.88631C22.4302 10.5346 22.1852 11.1147 21.6952 11.5582C21.2052 12.0018 20.6102 12.2406 19.9102 12.2406L18.2302 12.2065ZM18.2302 8.48736V11.217H19.9802C20.3652 11.217 20.7502 11.0805 20.9952 10.8076C21.5552 10.2958 21.5552 9.44274 21.0302 8.93093L20.9952 8.89681C20.7152 8.62385 20.3652 8.45324 19.9802 8.48736H18.2302Z"
            fill="#5F6368"
          />
          <path
            d="M24.8452 9.85217C25.6152 9.85217 26.2102 10.0569 26.6652 10.4663C27.1202 10.8758 27.3302 11.4217 27.3302 12.1041V15.3797H26.3502V14.6291H26.3152C25.8952 15.2432 25.3002 15.5503 24.6002 15.5503C24.0052 15.5503 23.4802 15.3797 23.0602 15.0385C22.6752 14.6973 22.4302 14.2196 22.4302 13.7078C22.4302 13.1619 22.6402 12.7183 23.0602 12.3771C23.4802 12.0359 24.0752 11.8994 24.7752 11.8994C25.4052 11.8994 25.8952 12.0018 26.2802 12.2406V12.0018C26.2802 11.6606 26.1402 11.3194 25.8602 11.1146C25.5802 10.8758 25.2302 10.7393 24.8452 10.7393C24.2502 10.7393 23.7952 10.9782 23.4802 11.4558L22.5702 10.9099C23.1302 10.1934 23.8652 9.85217 24.8452 9.85217ZM23.5152 13.7419C23.5152 14.0149 23.6552 14.2537 23.8652 14.3902C24.1102 14.5608 24.3902 14.6632 24.6702 14.6632C25.0902 14.6632 25.5102 14.4926 25.8252 14.1855C26.1752 13.8784 26.3502 13.5031 26.3502 13.0936C26.0352 12.8548 25.5802 12.7183 24.9852 12.7183C24.5652 12.7183 24.2152 12.8207 23.9352 13.0254C23.6552 13.196 23.5152 13.4349 23.5152 13.7419Z"
            fill="#5F6368"
          />
          <path
            d="M32.9999 10.0228L29.5349 17.7682H28.4849L29.7799 15.0727L27.5049 10.0569H28.6249L30.2699 13.9126H30.3049L31.9149 10.0569H32.9999V10.0228Z"
            fill="#5F6368"
          />
          <path
            d="M14.0651 11.5242C14.0651 11.2171 14.0301 10.91 13.9951 10.6029H9.62012V12.3431H12.1051C12.0001 12.889 11.6851 13.4008 11.1951 13.7079V14.8339H12.7001C13.5751 14.0491 14.0651 12.889 14.0651 11.5242Z"
            fill="#4285F4"
          />
          <path
            d="M9.62023 15.9257C10.8802 15.9257 11.9302 15.5163 12.7002 14.8338L11.1952 13.7079C10.7752 13.9808 10.2502 14.1514 9.62023 14.1514C8.43023 14.1514 7.38023 13.3666 7.03023 12.2748H5.49023V13.4349C6.29523 14.9703 7.87023 15.9257 9.62023 15.9257Z"
            fill="#34A853"
          />
          <path
            d="M7.02996 12.2748C6.81996 11.7288 6.81996 11.1147 7.02996 10.5346V9.37451H5.48996C4.82496 10.637 4.82496 12.1383 5.48996 13.4349L7.02996 12.2748Z"
            fill="#FBBC04"
          />
          <path
            d="M9.6199 8.69213C10.2849 8.69213 10.9149 8.93097 11.4049 9.37454L12.7349 8.07796C11.8949 7.3273 10.7749 6.88373 9.6549 6.91785C7.9049 6.91785 6.2949 7.87323 5.5249 9.40867L7.0649 10.5688C7.3799 9.47691 8.4299 8.69213 9.6199 8.69213Z"
            fill="#EA4335"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6206_121271">
          <rect width="38" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_6206_121271">
          <rect
            width="28"
            height="13"
            fill="white"
            transform="translate(5 5.48474)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GPay
